// src/utils/initFacebookPixel.js

export function initFacebookPixel() {
  if (typeof window === "undefined" || window.fbq) return;

  // Define a proxy fbq function that sends events to our backend CAPI route
  window.fbq = function (action, eventName, customData) {
    if (action !== "track" && action !== "trackCustom") return;
    
    const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
    
    // Check if token exists to attach it
    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
      "Accept": "application/json, text/plain, */*"
    };
    
    if (token) {
      headers["Authorization"] = token;
    }

    fetch(`${backendUrl}auth/track-event`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        eventName,
        customData,
        url: window.location.href
      })
    }).catch(err => console.error("FB Proxy Error:", err));
  };

  // We do not load the standard Facebook Pixel script anymore to bypass blockers.
  
  // Track initial page view
  window.fbq("track", "PageView");
}

